/* eslint-disable @next/next/no-img-element */
'use client';

import { FC, ImgHTMLAttributes } from 'react';
import { cn } from '@/utils';

type LazyNavImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt: string;
};

/** Header nav dropdown images — never LCP; must not compete for preload bandwidth. */
export const LazyNavImage: FC<LazyNavImageProps> = ({ src, alt, className, ...rest }) => (
  <img
    src={src}
    alt={alt}
    loading="lazy"
    decoding="async"
    className={cn('h-full w-full object-cover', className)}
    {...rest}
  />
);

export default LazyNavImage;
